export const ONBOARDING_LARGE_OVERLAY_HEADER_HEIGHT = 60;

export function onboardingLargeModalHeight(windowHeight: number): number {
  const available = Math.max(0, windowHeight - ONBOARDING_LARGE_OVERLAY_HEADER_HEIGHT);
  return Math.round(available * 0.9);
}
